import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export const CouldNotLoadApp = ({ errorState }: { errorState?: string }) => (
    <ErrorState
        outerClassName='margin-top-20'
        headline={'Page could not load'}
        message={
            errorState ? (
                <div className='margin-top-15 text-color-dark'>
                    <div>
                        <DetailedErrorExplanation errorState={errorState} />
                    </div>
                    <div>[{errorState}]</div>
                </div>
            ) : (
                <div className='margin-top-15 text-color-dark'>
                    Unfortunately, the page you are trying to access could not be loaded.
                </div>
            )
        }
    />
);

const DetailedErrorExplanation = ({ errorState }: { errorState: string }) => {
    if (errorState === 'NO_LOCAL_STORAGE') {
        return <div>Your browser does not support this page. Please try another browser.</div>;
    }
    return null;
};
